<template>
  <div class="paper-choice-set-time" v-loading="loading" element-loading-text="加载中...">
    <template v-if="batchTime">
      <div class="cont">
        <AppScrollbar style="height: 100%;">
          <TitleGroup :title="`导师双选（论文批次时间：${batchTime.startDate}- ${batchTime.endDate}）`">
            <el-form size="mini" label-width="130px" label-suffix="：">
              <el-form-item label="双选报名开始时间" required>
                <el-date-picker v-model="form.chooseStartDate"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="请选择双选报名开始时间"
                                size="mini"></el-date-picker>
              </el-form-item>
              <el-form-item label="双选报名截止时间" required>
                <el-date-picker v-model="form.chooseEndDate"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="请选择双选报名截止时间"
                                size="mini"></el-date-picker>
              </el-form-item>
              <el-form-item label="导师确认开始时间" required>
                <el-date-picker v-model="form.teacherChooseStartDate"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="请选择导师确认开始时间"
                                size="mini"></el-date-picker>
              </el-form-item>
              <el-form-item label="导师确认结束时间" required>
                <el-date-picker v-model="form.teacherChooseEndDate"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="请选择导师确认结束时间"
                                size="mini"></el-date-picker>
              </el-form-item>
            </el-form>
          </TitleGroup>
        </AppScrollbar>
      </div>
      <div class="footer">
        <el-button type="primary" size="mini" :loading="committing" @click="handleSubmit">保存设置</el-button>
      </div>
    </template>
    <Hint v-else v-show="errorMsg">
      <div>{{ errorMsg }}</div>
      <el-button type="text" @click="loadData">重新加载</el-button>
    </Hint>
  </div>
</template>

<script>
import AppScrollbar from '../../../../../../../elements/AppScrollbar.vue'
import TitleGroup from '../../../../../../../widgets/custom/TitleGroup'
import Hint from '../../../../../../../elements/Hint.vue'
export default {
  name: 'PaperChoiceSetTime',
  props: {
    paperBatchId: {
      type: String,
      required: true
    },
    activeTab: {
      type: Boolean,
      default: false
    }
  },
  components: {
    TitleGroup,
    Hint,
    AppScrollbar
  },
  data () {
    return {
      loading: false,
      committing: false,
      errorMsg: '',
      batchTime: null,
      form: {
        chooseStartDate: '',
        chooseEndDate: '',
        teacherChooseStartDate: '',
        teacherChooseEndDate: ''
      }
    }
  },
  methods: {
    loadData () {
      this.loading = true
      this.$ajax({
        method: 'post',
        url: '/workspace/manager/paper/choice/set/queryBatchTime',
        data: this.$qs.stringify({
          paperBatchId: this.paperBatchId
        })
      }).then(response => {
        if (response.data && response.data.errorCode === 0) {
          this.batchTime = response.data.batchTime
          if (!this.batchTime) {
            this.errorMsg = '暂无论文批次时间'
          }
        } else {
          this.errorMsg = response.data.message || '获取论文批次时间失败'
        }
      }, () => {
        this.errorMsg = '获取论文批次时间失败'
      }).finally(() => {
        this.loading = false
      })
    },
    handleSubmit () {
      const form = this.form
      if (!form.chooseStartDate) {
        this.$message.warning('请选择双选报名开始时间')
        return
      }
      if (!form.chooseEndDate) {
        this.$message.warning('请选择双选报名截止时间')
        return
      }
      if (!form.teacherChooseStartDate) {
        this.$message.warning('请选择导师确认开始时间')
        return
      }
      if (!form.teacherChooseEndDate) {
        this.$message.warning('请选择导师确认结束时间')
        return
      }
      this.committing = true
      this.$ajax({
        method: 'post',
        url: '/workspace/manager/paper/choice/set/saveBatchTime',
        data: this.$qs.stringify(this.$extend({
          paperBatchId: this.paperBatchId
        }, form))
      }).then(response => {
        if (response.data && response.data.errorCode === 0) {
          this.$message.success('保存成功')
        } else {
          this.$message.error(response.data.message || '保存失败')
        }
      }, () => {
        this.$message.error('保存失败')
      }).finally(() => {
        this.committing = false
      })
    }
  },
  watch: {
    activeTab: {
      handler (val) {
        if (val) {
          this.loadData()
        }
      },
      immediate: true
    },
    paperBatchId: {
      handler () {
        if (!this.activeTab) {
          return
        }
        this.loadData()
      }
    },
    batchTime: {
      handler (val) {
        if (val) {
          Object.keys(this.form).forEach(key => {
            if (val.hasOwnProperty(key)) {
              this.form[key] = val[key]
            }
          })
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.paper-choice-set-time{
  height: 100%;
  display: flex;
  flex-direction: column;
  & > .cont{
    flex: 1;
    height: 0;
    padding-top: 15px;
  }
  ::v-deep  .el-form{
    margin-top: 20px;
    & > .el-form-item{
      & > .el-form-item__label{
        font-size: 12px;
      }
    }
  }
  & > .footer{
    padding: 15px 0 10px;
    text-align: center;
  }
}
</style>
